import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { headers, getMeetingRoomMasterListUrl, insertUpdateMeetingRoomMasterUrl, deleteMeetingRoomMasterUrl, GET_MEETING_ROOM_MASTER_LIST, DELETE_MEETING_ROOM_MASTER, INSERT_UPDATE_MEETING_ROOM_MASTER } from "../../../../utils/constants";


export const insertUpdateMeetinRoomMaster_action = (MstMeetingRoomID, Date, RoomTypeID, SeatingCapacity, FromTime, ToTime, Location, RateInINR, RateInUSD) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            MstMeetingRoomID: MstMeetingRoomID,
            Date: Date,
            RoomTypeID: RoomTypeID,
            RoomTypeID: RoomTypeID,
            SeatingCapacity: SeatingCapacity,
            FromTime: FromTime,
            ToTime: ToTime,
            Location: Location,
            RateInINR: RateInINR,
            RateInUSD: RateInUSD,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(insertUpdateMeetingRoomMasterUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_MEETING_ROOM_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getMeetinRoomMasterList_action = (MstMeetingRoomID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            MstMeetingRoomID: MstMeetingRoomID
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getMeetingRoomMasterListUrl, params, headers)

        dispatch({
            type: GET_MEETING_ROOM_MASTER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteMeetinRoomMaster_action = (MstMeetingRoomID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            MstMeetingRoomID: MstMeetingRoomID
        }

        const res = await axiosGet(deleteMeetingRoomMasterUrl, params, headers)

        dispatch({
            type: DELETE_MEETING_ROOM_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}